import { render, staticRenderFns } from "./FiliaisView.vue?vue&type=template&id=fe8f3c40&scoped=true"
import script from "./FiliaisView.vue?vue&type=script&lang=js"
export * from "./FiliaisView.vue?vue&type=script&lang=js"
import style0 from "./FiliaisView.vue?vue&type=style&index=0&id=fe8f3c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8f3c40",
  null
  
)

export default component.exports